// Trilingual Clinical Knowledge Base for Sree Tekke Eye Clinic & Sight Care Society
// Languages: Marathi ('mr'), Kannada ('kn'), English ('en')

export const KNOWLEDGE_BASE = {
  welcome: {
    mr: {
      title: "नमस्ते! मी श्री टेके आय क्लिनिकचा AI सहाय्यक आहे.",
      message: "मी तुम्हाला नेत्रोपचार, डॉक्टर, क्लिनिकच्या शाखा, वेळ आणि अपॉइंटमेंट बुकिंगबद्दल सर्व माहिती देऊ शकतो. आज मी तुम्हाला कशी मदत करू?",
      quickActions: [
        { id: "cataract", label: "👁️ मोतीबिंदू शस्त्रक्रिया" },
        { id: "lasik", label: "⚡ लेसिक लेझर (चष्मा मुक्ती)" },
        { id: "appointment", label: "📅 अपॉइंटमेंट बुक करा" },
        { id: "branches", label: "🏥 शाखा व पत्ते" },
        { id: "doctors", label: "👨‍⚕️ तज्ज्ञ डॉक्टर" },
        { id: "insurance", label: "🛡️ कॅशलेस इन्शुरन्स" }
      ]
    },
    kn: {
      title: "ನಮಸ್ಕಾರ! ನಾನು ಶ್ರೀ ಟೆಕ್ಕೆ ಕಣ್ಣಿನ ಆಸ್ಪತ್ರೆಯ AI ಸಹಾಯಕ.",
      message: "ಕಣ್ಣಿನ ಚಿಕಿತ್ಸೆಗಳು, ವೈದ್ಯರು, ಆಸ್ಪತ್ರೆಯ ಶಾಖೆಗಳು, ಸಮಯ ಮತ್ತು ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಬುಕಿಂಗ್ ಬಗ್ಗೆ ನಾನು ನಿಮಗೆ ಸಂಪೂರ್ಣ ಮಾಹಿತಿ ನೀಡಬಲ್ಲೆ. ಇಂದು ನಾನು ನಿಮಗೆ ಹೇಗೆ ಸಹಾಯ ಮಾಡಲಿ?",
      quickActions: [
        { id: "cataract", label: "👁️ ಮೋತಿಬಿಂದು ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ" },
        { id: "lasik", label: "⚡ ಲ್ಯಾಸಿಕ್ ಲೇಸರ್ (ಕನ್ನಡಕ ಮುಕ್ತಿ)" },
        { id: "appointment", label: "📅 ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಬುಕ್ ಮಾಡಿ" },
        { id: "branches", label: "🏥 ಶಾಖೆಗಳು ಮತ್ತು ವಿಳಾಸ" },
        { id: "doctors", label: "👨‍⚕️ ತಜ್ಞ ವೈದ್ಯರು" },
        { id: "insurance", label: "🛡️ ಕ್ಯಾಶ್‌ಲೆಸ್ ವಿಮೆ" }
      ]
    },
    en: {
      title: "Hello! Welcome to Sree Tekke Eye Clinic AI Assistant.",
      message: "I can help you with eye treatments, specialists, clinic branch locations, timings, insurance, and booking an appointment. How can I assist you today?",
      quickActions: [
        { id: "cataract", label: "👁️ Cataract Surgery" },
        { id: "lasik", label: "⚡ LASIK (Specs Removal)" },
        { id: "appointment", label: "📅 Book Appointment" },
        { id: "branches", label: "🏥 Branches & Timings" },
        { id: "doctors", label: "👨‍⚕️ Specialists" },
        { id: "insurance", label: "🛡️ Cashless Insurance" }
      ]
    }
  },

  topics: {
    cataract: {
      mr: {
        text: `**श्री टेके आय क्लिनिक - मोतीबिंदू (Cataract) उपचार:**\n\n• **आधुनिक तंत्रज्ञान:** फेकोइमल्सिफिकेशन (Phaco) आणि टाकेविरहित सूक्ष्म-छेदन शस्त्रक्रिया (MICS - No Injection, No Stitch, No Patch).\n• **प्रीमियम लेन्स पर्याय:** मोनोफोकल, मल्टिफोकल आणि टोरिक लेन्स - शस्त्रक्रियेनंतर चष्म्याशिवाय स्पष्ट दृष्टी.\n• **फायदे:** अवघ्या १०-१५ मिनिटांची प्रक्रिया, त्याच दिवशी डिस्चार्ज, जलद रिकव्हरी.\n• **कॅशलेस सुविधा:** महात्मा फुले जन आरोग्य योजना व सर्व प्रमुख मेडिक्लेम इन्शुरन्स उपलब्ध!`,
        action: { label: "📅 मोतीबिंदू तपासणी बुक करा", type: "appointment", service: "stitchless-cataract-surgery" }
      },
      kn: {
        text: `**ಶ್ರೀ ಟೆಕ್ಕೆ ಕಣ್ಣಿನ ಆಸ್ಪತ್ರೆ - ಮೋತಿಬಿಂದು (Cataract) ಚಿಕಿತ್ಸೆ:**\n\n• **ಆಧುನಿಕ ತಂತ್ರಜ್ಞಾನ:** ಫ್ಯಾಕೊ ಮತ್ತು ಹೊಲಿಗೆ ರಹಿತ ಮೈಕ್ರೋ-ಇನ್ಸಿಷನ್ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ (MICS - ನೋ ಇಂಜೆಕ್ಷನ್, ನೋ ಸ್ಟಿಚ್, ನೋ ಪ್ಯಾಚ್).\n• **ಪ್ರೀಮಿಯಂ ಲೆನ್ಸ್‌ಗಳು:** ಮೊನೊಫೋಕಲ್, ಮಲ್ಟಿಫೋಕಲ್ ಮತ್ತು ಟೋರಿಕ್ ಲೆನ್ಸ್‌ಗಳು - ಕನ್ನಡಕವಿಲ್ಲದೆ ಸ್ಪಷ್ಟ ದೃಷ್ಟಿ.\n• **ಲಾಭಗಳು:** ಕೇವಲ ೧೦-೧೫ ನಿಮಿಷಗಳ ಚಿಕಿತ್ಸೆ, ಅಂದೇ ಡಿಸ್ಚಾರ್ಜ್, ವೇಗದ ಗುಣಮುಖತೆ.\n• **ಕ್ಯಾಶ್‌ಲೆಸ್ ಸೌಲಭ್ಯ:** ಆಯುಷ್ಮಾನ್ ಭಾರತ್ ಮತ್ತು ಎಲ್ಲಾ ಪ್ರಮುಖ ವಿಮೆ (Mediclaim) ಲಭ್ಯ!`,
        action: { label: "📅 ಮೋತಿಬಿಂದು ತಪಾಸಣೆ ಬುಕ್ ಮಾಡಿ", type: "appointment", service: "stitchless-cataract-surgery" }
      },
      en: {
        text: `**Sree Tekke Eye Clinic - Advanced Cataract Surgery:**\n\n• **Technology:** Stitchless Micro-Incision Cataract Surgery (MICS) & Phacoemulsification (No injection, No stitches, No bandage).\n• **Premium IOL Implants:** Monofocal, Toric & Multifocal lenses for crystal clear vision at all distances without glasses.\n• **Benefits:** 10-15 min quick procedure, same-day discharge, rapid healing.\n• **Cashless Facility:** Empanelled with major TPAs, Mediclaim & Govt health schemes.`,
        action: { label: "📅 Book Cataract Consultation", type: "appointment", service: "stitchless-cataract-surgery" }
      }
    },

    lasik: {
      mr: {
        text: `**लेसिक लेझर (LASIK) - चष्म्यापासून कायमची मुक्ती:**\n\n• **प्रक्रिया:** ब्लेडविरहित (Bladeless) अत्याधुनिक रोबोटिक लेझर तंत्रज्ञान.\n• **कोणासाठी उपयुक्त:** १८ वर्षांवरील व्यक्ती ज्यांचा चष्म्याचा नंबर स्थिर आहे.\n• **कालावधी:** दोन्ही डोळ्यांसाठी केवळ १०-१५ मिनिटे, वेदनारहित आणि सुरक्षित.\n• **परिणाम:** दुसऱ्याच दिवशी स्वच्छ आणि स्पष्ट नैसर्गिक दृष्टी!`,
        action: { label: "⚡ लेसिक तपासणीसाठी नोंदणी करा", type: "appointment", service: "lasik-laser" }
      },
      kn: {
        text: `**ಲ್ಯಾಸಿಕ್ ಲೇಸರ್ (LASIK) - ಕನ್ನಡಕದಿಂದ ಶಾಶ್ವತ ಮುಕ್ತಿ:**\n\n• **ವಿಧಾನ:** ಬ್ಲೇಡ್ ರಹಿತ ಅತ್ಯಾಧುನಿಕ ರೋಬೋಟಿಕ್ ಲೇಸರ್ ತಂತ್ರಜ್ಞಾನ.\n• **ಯಾರಿಗೆ ಸೂಕ್ತ:** ೧೮ ವರ್ಷ ಮೇಲ್ಪಟ್ಟ, ಸ್ಥಿರ ಕನ್ನಡಕ ನಂಬರ್ ಇರುವವರಿಗೆ.\n• **ಸಮಯ:** ಕೇವಲ ೧೦-೧೫ ನಿಮಿಷಗಳ ವೇದನಾರಹಿತ, ಅತ್ಯಂತ ಸುರಕ್ಷಿತ ಪ್ರಕ್ರಿಯೆ.\n• **ಫಲಿತಾಂಶ:** ಮರುದಿನವೇ ಸ್ಪಷ್ಟ ನೈಸರ್ಗಿಕ ದೃಷ್ಟಿ ಮರಳಿ ಪಡೆಯಿರಿ!`,
        action: { label: "⚡ ಲ್ಯಾಸಿಕ್ ತಪಾಸಣೆ ಬುಕ್ ಮಾಡಿ", type: "appointment", service: "lasik-laser" }
      },
      en: {
        text: `**LASIK Laser Vision Correction - Freedom from Glasses:**\n\n• **Procedure:** Blade-free customized laser vision correction.\n• **Eligibility:** Age 18+ with stable spectacle prescription.\n• **Duration:** Painless 10-15 minute procedure for both eyes.\n• **Outcome:** Sharp, crystal-clear 20/20 vision by the very next morning!`,
        action: { label: "⚡ Book LASIK Screening", type: "appointment", service: "lasik-laser" }
      }
    },

    glaucoma: {
      mr: {
        text: `**काचबिंदू (Glaucoma) उपचार व शस्त्रक्रिया:**\n\n• काचबिंदू हा डोळ्यातील दाब वाढल्यामुळे ऑप्टिक नर्व्हला इजा पोहोचवणारा आजार आहे.\n• आमच्याकडे अत्याधुनिक कॉम्प्युटराइज्ड व्हिज्युअल फील्ड ॲनालिसिस (Perimetry) व OCT स्कॅनिंग उपलब्ध आहे.\n• वेळीच औषधोपचार, लेझर थेरपी किंवा ट्रॅबेक्युलेक्टॉमी शस्त्रक्रियेने दृष्टीचे रक्षण केले जाते.`,
        action: { label: "📅 काचबिंदू तपासणी बुक करा", type: "appointment", service: "glaucoma-treatment" }
      },
      kn: {
        text: `**ಕಾಚುಬಿಂದು / ಗ್ಲುಕೋಮಾ (Glaucoma) ಚಿಕಿತ್ಸೆ:**\n\n• ಕಣ್ಣಿನ ಒಳಗಿನ ಒತ್ತಡ ಹೆಚ್ಚಾಗುವುದರಿಂದ ಆಪ್ಟಿಕ್ ನರಗಳಿಗೆ ಹಾನಿಯಾಗುವುದನ್ನು ತಡೆಯಲು ನಿಯಮಿತ ತಪಾಸಣೆ ಅಗತ್ಯ.\n• ಕಂಪ್ಯೂಟರೀಕೃತ ದೃಷ್ಟಿ ಪರೀಕ್ಷೆ (Perimetry) ಮತ್ತು OCT 3D ಸ್ಕ್ಯಾನ್ ಸೌಲಭ್ಯ.\n• ಡ್ರಾಪ್ಸ್, ಲೇಸರ್ ಚಿಕಿತ್ಸೆ ಮತ್ತು ಪರಿಣಿತ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ ಲಭ್ಯವಿದೆ.`,
        action: { label: "📅 ಗ್ಲುಕೋಮಾ ತಪಾಸಣೆ ಬುಕ್ ಮಾಡಿ", type: "appointment", service: "glaucoma-treatment" }
      },
      en: {
        text: `**Glaucoma (Kachbindu) Diagnosis & Care:**\n\n• Early screening for elevated Intraocular Pressure (IOP) to safeguard your optic nerve.\n• Advanced Automated Visual Field Analysis (Perimetry) & High-Definition OCT scans.\n• Comprehensive medical management, laser trabeculoplasty, and filtration surgery.`,
        action: { label: "📅 Book Glaucoma Checkup", type: "appointment", service: "glaucoma-treatment" }
      }
    },

    retina: {
      mr: {
        text: `**रेटिना (पडदा) आणि मधुमेह (Diabetic Retinopathy) उपचार:**\n\n• **OCT 3D स्कॅन:** डोळ्याच्या पडद्याची सूक्ष्म आणि अचूक तपासणी.\n• **डायबेटिस नेत्र तपासणी:** मधुमेहामुळे डोळ्यांवर होणारे दुष्परिणाम रोखण्यासाठी ग्रीन लेझर फोटोकॉग्युलेशन व अँटी-VEGF इंजेक्शन्स.\n• पडदा सरकणे (Retinal Detachment) व विट्रिओ-रेटिना शस्त्रक्रियांचे विशेष युनिट.`,
        action: { label: "👁️ रेटिना तपासणी बुक करा", type: "appointment", service: "oct-retina-screening" }
      },
      kn: {
        text: `**ರೆಟಿನಾ ಮತ್ತು ಮಧುಮೇಹ ಕಣ್ಣಿನ ಚಿಕಿತ್ಸೆ:**\n\n• **OCT 3D ಸ್ಕ್ಯಾನಿಂಗ್:** ರೆಟಿನಾ ಪದರಗಳ ಹೈ-ಡೆಫಿನಿಷನ್ ತಪಾಸಣೆ.\n• **ಡಯಾಬಿಟಿಕ್ ರೆಟಿನೋಪತಿ:** ಗ್ರೀನ್ ಲೇಸರ್ ಮತ್ತು ಆಂಟಿ-VEGF ಇಂಜೆಕ್ಷನ್‌ಗಳು.\n• ರೆಟಿನಲ್ ಡಿಟ್ಯಾಚ್‌ಮೆಂಟ್ ಮತ್ತು ಮ್ಯಾಕ್ಯುಲರ್ ತೊಂದರೆಗಳಿಗೆ ಪರಿಣಿತ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ.`,
        action: { label: "👁️ ರೆಟಿನಾ ತಪಾಸಣೆ ಬುಕ್ ಮಾಡಿ", type: "appointment", service: "oct-retina-screening" }
      },
      en: {
        text: `**Retina Care & Diabetic Retinopathy Center:**\n\n• **OCT 3D Imaging:** High-resolution cross-sectional scan of retinal layers.\n• **Diabetic Eye Screening:** Green laser photocoagulation & targeted Anti-VEGF injections.\n• Vitreoretinal surgery for retinal detachment and macular diseases.`,
        action: { label: "👁️ Book Retina Consultation", type: "appointment", service: "oct-retina-screening" }
      }
    },

    squint: {
      mr: {
        text: `**तिरळेपणा (Squint) आणि बालरोग नेत्रचिकित्सा:**\n\n• लहान मुलांमधील आणि मोठ्यांमधील तिरळेपणावर अचूक निदान व उपचार.\n• डोळ्यांच्या स्नायूंचे व्यायाम (Orthoptics), चष्मा आणि अत्याधुनिक कॉस्मेटिक दुरुस्ती शस्त्रक्रिया.\n• लहान मुलांमधील आळशी डोळा (Amblyopia) उपचार.`,
        action: { label: "📅 तिरळेपणा तपासणी बुक करा", type: "appointment", service: "squint-treatment" }
      },
      kn: {
        text: `**ಮೆಳ್ಳೆಗಣ್ಣು (Squint) ಮತ್ತು ಮಕ್ಕಳ ಕಣ್ಣಿನ ಚಿಕಿತ್ಸೆ:**\n\n• ಮಕ್ಕಳು ಹಾಗೂ ಹಿರಿಯರಲ್ಲಿ ಕಂಡುಬರುವ ಮೆಳ್ಳೆಗಣ್ಣಿಗೆ ಅತ್ಯಾಧುನಿಕ ಪರಿಹಾರ.\n• ವಿಶೇಷ ವ್ಯಾಯಾಮಗಳು ಮತ್ತು ನಿಖರ ಸ್ನಾಯು ತಿದ್ದುಪಡಿ ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ.\n• ಮಕ್ಕಳ ಸೋಮಾರಿ ಕಣ್ಣು (Amblyopia) ಚಿಕಿತ್ಸೆ.`,
        action: { label: "📅 ತಪಾಸಣೆ ಬುಕ್ ಮಾಡಿ", type: "appointment", service: "squint-treatment" }
      },
      en: {
        text: `**Squint (Strabismus) & Pediatric Ophthalmology:**\n\n• Accurate evaluation and correction for squint in both children and adults.\n• Orthoptic exercises, specialized optical prism correction, and muscle alignment surgery.\n• Treatment for lazy eye (amblyopia) and pediatric vision development.`,
        action: { label: "📅 Book Squint Evaluation", type: "appointment", service: "squint-treatment" }
      }
    },

    doctors: {
      mr: {
        text: `**श्री टेके आय क्लिनिकचे तज्ज्ञ डॉक्टर:**\n\n👨‍⚕️ **डॉ. रमाकांत टेके**\n• वरिष्ठ नेत्रतज्ज्ञ (Senior Ophthalmologist)\n• मोतीबिंदू, फेको व सर्वसमावेशक नेत्रोपचार तज्ज्ञ\n\n👩‍⚕️ **डॉ. विशाखा टेके**\n• M.S. (Ophthal) & M.B.B.S., D.O.M.S.\n• नेत्र शल्यचिकित्सक (Eye Surgeon)\n• लेसिक, आधुनिक मोतीबिंदू व व्हिजन करेक्शन विशेषज्ञ`,
        action: { label: "📅 डॉक्टरांशी भेट निश्चित करा", type: "appointment" }
      },
      kn: {
        text: `**ಶ್ರೀ ಟೆಕ್ಕೆ ಕಣ್ಣಿನ ಆಸ್ಪತ್ರೆಯ ತಜ್ಞ ವೈದ್ಯರು:**\n\n👨‍⚕️ **ಡಾ. ರಮಾಕಾಂತ ಟೆಕ್ಕೆ**\n• ಹಿರಿಯ ನೇತ್ರತಜ್ಞರು (Senior Ophthalmologist)\n• ಮೋತಿಬಿಂದು, ಫ್ಯಾಕೊ ಮತ್ತು ಸಮಗ್ರ ಕಣ್ಣಿನ ಚಿಕಿತ್ಸಾ ಪರಿಣಿತರು\n\n👩‍⚕️ **ಡಾ. ವಿಶಾಖಾ ಟೆಕ್ಕೆ**\n• M.S. (Ophthal) & M.B.B.S., D.O.M.S.\n• ಕಣ್ಣಿನ ಶಸ್ತ್ರಚಿಕಿತ್ಸಕಿ (Eye Surgeon)\n• ಲ್ಯಾಸಿಕ್, ಸುಧಾರಿತ ಕಣ್ಣಿನ ಶಸ್ತ್ರಚಿಕಿತ್ಸಾ ತಜ್ಞೆ`,
        action: { label: "📅 ವೈದ್ಯರ ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಬುಕ್ ಮಾಡಿ", type: "appointment" }
      },
      en: {
        text: `**Our Senior Specialists at Sree Tekke Eye Clinic:**\n\n👨‍⚕️ **Dr. Ramakant Tekke**\n• Senior Ophthalmologist & Eye Specialist\n• Decades of surgical excellence in Cataract, Phaco & Comprehensive Care\n\n👩‍⚕️ **Dr. Vishakha Tekke**\n• M.S. (Opth), M.B.B.S., D.O.M.S.\n• Renowned Eye Surgeon & Vision Correction Specialist\n• Expert in LASIK, MICS Cataract, and Advanced Ophthalmic Surgery`,
        action: { label: "📅 Book Doctor Consultation", type: "appointment" }
      }
    },

    branches: {
      mr: {
        text: `**आमच्या ६ प्रमुख शाखा व संपर्क:**\n\n१. **आष्टा (Astha):** रुकडे पेट्रोल पंपजवळ, मुख्य रस्ता | 📞 99232 42655\n२. **जत (Jath):** जलवाडी कॉम्प्लेक्स, जत | 📞 99232 42755\n३. **आटपाडी (Atpadi):** एस.टी. स्टँडजवळ, रोवेएट हॉस्पिटलवर | 📞 90284 96584\n४. **सोलापूर (Solapur):** माजी सैनिक नगर, विजापूर रोड | 📞 70301 19119\n५. **अथणी (Athani):** शांतिनगर, हल्याल रोड | 📞 98441 22001\n६. **सांगोला (Sangola):** माउली हाइट्स, मिरज रोड | 📞 99161 08116\n\n⏰ **वेळ:** सोमा-शनि सकाळी ९ ते रात्री ८ | रविवार सकाळी ९ ते दुपारी १`,
        action: { label: "📍 जवळची शाखा शोधा", type: "navigate", url: "/branches" }
      },
      kn: {
        text: `**ನಮ್ಮ ೬ ಪ್ರಮುಖ ಶಾಖೆಗಳು ಮತ್ತು ವಿಳಾಸ:**\n\n೧. **ಅಷ್ಟಾ (Astha):** ರುಕಡೆ ಪೆಟ್ರೋಲ್ ಪಂಪ್ ಹತ್ತಿರ, ಮುಖ್ಯ ರಸ್ತೆ | 📞 99232 42655\n೨. **ಜತ್ (Jath):** ಜಲವಾಡಿ ಕಾಂಪ್ಲೆಕ್ಸ್, ಜತ್ | 📞 99232 42755\n೩. **ಆಟಪಾಡಿ (Atpadi):** ಕೆ.ಎಸ್.ಆರ್.ಟಿ.ಸಿ ಬಸ್ ನಿಲ್ದಾಣ ಹತ್ತಿರ | 📞 90284 96584\n೪. **ಸೊಲ್ಲಾಪುರ (Solapur):** ಮಾಜಿ ಸೈನಿಕ ನಗರ, ವಿಜಾಪುರ ರಸ್ತೆ | 📞 70301 19119\n೫. **ಅಥಣಿ (Athani):** ಶಾಂತಿನಗರ, ಹಲ್ಯಾಳ ರಸ್ತೆ | 📞 98441 22001\n೬. **ಸಾಂಗೋಲಾ (Sangola):** ಮೌಲಿ ಹೈಟ್ಸ್, ಮಿರಜ್ ರಸ್ತೆ | 📞 99161 08116\n\n⏰ **ಸಮಯ:** ಸೋಮ-ಶನಿ ಬೆಳಗ್ಗೆ ೯ ರಿಂದ ರಾತ್ರಿ ೮ | ಭಾನುವಾರ ಬೆಳಗ್ಗೆ ೯ ರಿಂದ ಮಧ್ಯಾಹ್ನ ೧`,
        action: { label: "📍 ಹತ್ತಿರದ ಶಾಖೆ ವೀಕ್ಷಿಸಿ", type: "navigate", url: "/branches" }
      },
      en: {
        text: `**Our 6 Clinic Branches & Contact Numbers:**\n\n1. **Astha:** Near Rukade Petrol Pump, Main Road | 📞 +91 99232 42655\n2. **Jath:** Jal Wadi Complex, Jath | 📞 +91 99232 42755\n3. **Atpadi:** Near S.T. Stand, Top of Roweat Hospital | 📞 +91 90284 96584\n4. **Solapur:** Maji Sainik Nagar, Vijapur Road | 📞 +91 70301 19119\n5. **Athani:** Shantinagar, Halyal Road | 📞 +91 98441 22001\n6. **Sangola:** Mauli Heights, Miraj Road | 📞 +91 99161 08116\n\n⏰ **General OPD:** Mon-Sat: 9:00 AM - 8:00 PM | Sun: 9:00 AM - 1:00 PM`,
        action: { label: "📍 View Branch Details", type: "navigate", url: "/branches" }
      }
    },

    insurance: {
      mr: {
        text: `**कॅशलेस इन्शुरन्स व सरकारी योजना:**\n\n• **सरकारी योजना:** महात्मा ज्योतिराव फुले जन आरोग्य योजना (MJPJAY) व आयुष्मान भारत अंतर्गत मोतीबिंदू शस्त्रक्रिया मोफत/सवलतीच्या दरात.\n• **प्रायव्हेट मेडिक्लेम:** Star Health, Care Health, HDFC ERGO, ICICI Lombard, New India, National Insurance व सर्व प्रमुख TPA कंपन्यांद्वारे कॅशलेस सुविधा उपलब्ध.\n• **कागदपत्रे:** आधार कार्ड, रेशन कार्ड आणि इन्शुरन्स ई-कार्ड.`,
        action: { label: "🛡️ इन्शुरन्स चौकशीसाठी कॉल करा", type: "tel", number: "+917083592101" }
      },
      kn: {
        text: `**ಕ್ಯಾಶ್‌ಲೆಸ್ ವಿಮೆ ಮತ್ತು ಸರ್ಕಾರಿ ಯೋಜನೆಗಳು:**\n\n• **ಸರ್ಕಾರಿ ಯೋಜನೆ:** ಆಯುಷ್ಮಾನ್ ಭಾರತ್ ಮತ್ತು ಆರೋಗ್ಯ ಕರ್ನಾಟಕ ಸೌಲಭ್ಯಗಳು.\n• **ಖಾಸಗಿ ಮೆಡಿಕ್ಲೇಮ್:** Star Health, Care Health, HDFC ERGO, ICICI Lombard ಮತ್ತು ಎಲ್ಲಾ ಪ್ರಮುಖ TPA ಕ್ಯಾಶ್‌ಲೆಸ್ ಸೌಲಭ್ಯಗಳು ಲಭ್ಯ.\n• **ದಾಖಲೆಗಳು:** ಆಧಾರ್ ಕಾರ್ಡ್, ರೇಷನ್ ಕಾರ್ಡ್ ಮತ್ತು ವಿಮಾ ಕಾರ್ಡ್ ತನ್ನಿ.`,
        action: { label: "🛡️ ವಿಮೆ ವಿಚಾರಣೆಗಾಗಿ ಕರೆ ಮಾಡಿ", type: "tel", number: "+917083592101" }
      },
      en: {
        text: `**Cashless Insurance & Government Schemes:**\n\n• **Government Schemes:** Ayushman Bharat (PM-JAY) & Mahatma Jyotirao Phule Jan Arogya Yojana.\n• **Private Mediclaim & TPAs:** Seamless cashless claims with Star Health, Care, HDFC ERGO, ICICI Lombard, New India, United India, Medi Assist, Paramount, and more.\n• **Quick On-Desk Assistance:** Our insurance desk handles pre-authorization and documentation swiftly.`,
        action: { label: "🛡️ Call Insurance Helpdesk", type: "tel", number: "+917083592101" }
      }
    },

    appointment: {
      mr: {
        text: `**अपॉइंटमेंट बुकिंग पर्याय:**\n\n१. **ऑनलाइन फॉर्म:** खालील बटण दाबून काही सेकंदात तारीख व वेळ निवडा.\n२. **फोन कॉल:** थेट कॉल करा - 📞 **70835 92101** किंवा **99232 42655**.\n३. **व्हॉट्सॲप:** व्हॉट्सॲपवर नाव व तारीख पाठवून तात्काळ पुष्टी मिळवा.`,
        action: { label: "📅 ऑनलाइन अपॉइंटमेंट फॉर्म उघडा", type: "appointment" }
      },
      kn: {
        text: `**ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಬುಕಿಂಗ್ ವಿಧಾನಗಳು:**\n\n೧. **ಆನ್‌ಲೈನ್ ಫಾರ್ಮ್:** ಕೆಳಗಿನ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ ನಿಮ್ಮ ದಿನಾಂಕ ಮತ್ತು ಸಮಯ ಆಯ್ಕೆಮಾಡಿ.\n೨. **ಫೋನ್ ಕರೆ:** ನೇರ ಕರೆ ಮಾಡಿ - 📞 **70835 92101** ಅಥವಾ **99232 42655**.\n೩. **ವಾಟ್ಸಾಪ್:** ವಾಟ್ಸಾಪ್ ಮೂಲಕ ಕ್ಷಣಾರ್ಧದಲ್ಲಿ ಬುಕ್ ಮಾಡಿ.`,
        action: { label: "📅 ಆನ್‌ಲೈನ್ ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಫಾರ್ಮ್", type: "appointment" }
      },
      en: {
        text: `**Book Your Consultation:**\n\n1. **Online Booking:** Click below to choose your doctor, branch, and preferred time.\n2. **Direct Helpline:** Call 📞 **+91 70835 92101** or **+91 99232 42655**.\n3. **WhatsApp Instant Confirm:** Connect with our reception directly on WhatsApp.`,
        action: { label: "📅 Open Appointment Form", type: "appointment" }
      }
    },

    emergency: {
      mr: {
        text: `🚨 **नेत्र आणीबाणी (Eye Emergency) हेल्पलाइन:**\n\nडोळ्याला अचानक गंभीर इजा, तीव्र वेदना, रासायनिक जखम किंवा दृष्टी अचानक अंधुक झाल्यास विलंब न करता तात्काळ संपर्क करा:\n\n📞 **इमर्जन्सी २४/७:** +91 70835 92101\n📞 **आष्टा क्लिनिक:** +91 99232 42655`,
        action: { label: "🚨 आताच कॉल करा (+91 70835 92101)", type: "tel", number: "+917083592101" }
      },
      kn: {
        text: `🚨 **ತುರ್ತು ನೇತ್ರ ಸೇವೆ (Eye Emergency) ಸಹಾಯವಾಣಿ:**\n\nಕಣ್ಣಿಗೆ ಹಠಾತ್ ಗಾಯ, ತೀವ್ರ ನೋವು, ರಾಸಾಯನಿಕ ಸಿಂಪರಣೆ ಅಥವಾ ದೃಷ್ಟಿ ನಷ್ಟ ಸಂಭವಿಸಿದಲ್ಲಿ ತಕ್ಷಣ ಸಂಪರ್ಕಿಸಿ:\n\n📞 **ತುರ್ತು ಸೇವೆ ೨೪/೭:** +91 70835 92101\n📞 **ಅಷ್ಟಾ ಆಸ್ಪತ್ರೆ:** +91 99232 42655`,
        action: { label: "🚨 ತಕ್ಷಣ ಕರೆ ಮಾಡಿ (+91 70835 92101)", type: "tel", number: "+917083592101" }
      },
      en: {
        text: `🚨 **24/7 Eye Emergency Assistance:**\n\nFor sudden vision loss, sharp ocular trauma, chemical splashes, or acute intense eye pain, reach our emergency triage immediately:\n\n📞 **Emergency Hotline:** +91 70835 92101\n📞 **Main Astha Center:** +91 99232 42655`,
        action: { label: "🚨 Call Emergency Hotline Now", type: "tel", number: "+917083592101" }
      }
    }
  }
};

// Intent matcher helper supporting Marathi, Kannada, English
export const matchUserIntent = (query, currentLang = 'mr') => {
  if (!query || typeof query !== 'string') return null;
  const q = query.toLowerCase().trim();

  // Emergency
  if (
    q.includes('emergency') || q.includes('accident') || q.includes('urgent') ||
    q.includes('इमर्जन्सी') || q.includes('तातडी') || q.includes('गंभीर') ||
    q.includes('ತುರ್ತು') || q.includes('ಅಪಘಾತ')
  ) {
    return 'emergency';
  }

  // Cataract / Motibindu
  if (
    q.includes('cataract') || q.includes('motibindu') || q.includes('moti bindu') ||
    q.includes('मोतीबिंदू') || q.includes('मोतीबिंदु') || q.includes('फेको') || q.includes('phaco') ||
    q.includes('ಮೋತಿಬಿಂದು') || q.includes('ಲೆನ್ಸ್') || q.includes('ಮೋತಿಯ')
  ) {
    return 'cataract';
  }

  // LASIK / Specs removal
  if (
    q.includes('lasik') || q.includes('specs') || q.includes('glasses') || q.includes('number') ||
    q.includes('लेसिक') || q.includes('चष्मा') || q.includes('नंबर') || q.includes('लेझर') ||
    q.includes('ಲ್ಯಾಸಿಕ್') || q.includes('ಕನ್ನಡಕ') || q.includes('ಲೇಸರ್')
  ) {
    return 'lasik';
  }

  // Glaucoma / Kachbindu
  if (
    q.includes('glaucoma') || q.includes('pressure') || q.includes('kachbindu') ||
    q.includes('काचबिंदू') || q.includes('काचबिंदु') || q.includes('दाब') ||
    q.includes('ಕಾಚುಬಿಂದು') || q.includes('ಗ್ಲುಕೋಮಾ')
  ) {
    return 'glaucoma';
  }

  // Retina / Diabetes
  if (
    q.includes('retina') || q.includes('diabet') || q.includes('sugar') || q.includes('oct') ||
    q.includes('रेटिना') || q.includes('पडदा') || q.includes('मधुमेह') || q.includes('डायबिटीस') ||
    q.includes('ರೆಟಿನಾ') || q.includes('ಮಧುಮೇಹ')
  ) {
    return 'retina';
  }

  // Squint
  if (
    q.includes('squint') || q.includes('tirla') || q.includes('strabismus') ||
    q.includes('तिरळेपणा') || q.includes('तिरळा') ||
    q.includes('ಮೆಳ್ಳೆಗಣ್ಣು') || q.includes('ಮೆಳ್ಳೆ')
  ) {
    return 'squint';
  }

  // Doctors
  if (
    q.includes('doctor') || q.includes('dr') || q.includes('ramakant') || q.includes('vishakha') ||
    q.includes('डॉक्टर') || q.includes('रमाकांत') || q.includes('विशाखा') || q.includes('सर्जन') ||
    q.includes('ವೈದ್ಯ') || q.includes('ಡಾಕ್ಟರ್') || q.includes('ಡಾ')
  ) {
    return 'doctors';
  }

  // Branches / Locations
  if (
    q.includes('branch') || q.includes('address') || q.includes('location') || q.includes('timing') ||
    q.includes('astha') || q.includes('jath') || q.includes('atpadi') || q.includes('solapur') || q.includes('athani') || q.includes('sangola') ||
    q.includes('शाखा') || q.includes('पत्ता') || q.includes('वेळ') || q.includes('कुठे') ||
    q.includes('आष्टा') || q.includes('जत') || q.includes('आटपाडी') || q.includes('सोलापूर') || q.includes('अथणी') || q.includes('सांगोला') ||
    q.includes('ಶಾಖೆ') || q.includes('ವಿಳಾಸ') || q.includes('ಸಮಯ') || q.includes('ಎಲ್ಲಿದೆ')
  ) {
    return 'branches';
  }

  // Insurance / Cashless
  if (
    q.includes('insurance') || q.includes('cashless') || q.includes('tpa') || q.includes('ayushman') || q.includes('mediclaim') ||
    q.includes('इन्शुरन्स') || q.includes('कॅशलेस') || q.includes('मेडीक्लेम') || q.includes('योजना') ||
    q.includes('ವಿಮೆ') || q.includes('ಕ್ಯಾಶ್‌ಲೆಸ್') || q.includes('ಯೋಜನೆ')
  ) {
    return 'insurance';
  }

  // Appointment / Booking
  if (
    q.includes('appoint') || q.includes('book') || q.includes('fees') || q.includes('cost') || q.includes('opd') ||
    q.includes('अपॉइंटमेंट') || q.includes('नोंदणी') || q.includes('फी') || q.includes('खर्च') ||
    q.includes('ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್') || q.includes('ಬುಕ್') || q.includes('ಶುಲ್ಕ')
  ) {
    return 'appointment';
  }

  return null;
};
